import React from "react";
import { Link } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h2 className="font-display text-2xl font-bold text-agri-forest-900 dark:text-white">
          Reset your password
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Remember your password?{" "}
          <Link
            to="/auth/login"
            className="font-medium text-green-600 hover:text-green-500"
          >
            Sign in
          </Link>
        </p>
      </div>

      <div className="text-center py-8">
        <p className="text-gray-500 dark:text-gray-400">
          Password reset page coming soon...
        </p>
        <Link to="/auth/login" className="mt-4 inline-block btn-primary">
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
